module.exports = __webpack_public_path__ + "static/media/ph.807a7e5d.svg";